import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';

const ProtectedRoutes: React.FC = (): React.ReactElement => {
  const { isAuthenticated } = useAuth();
  const { i18n } = useTranslation();
  let link = '/en/login'
  if (i18n.language !== 'en') {
  	link = 'כְּנִיסָה-לַמַעֲרֶכֶת'
	}
  return isAuthenticated() ? <Outlet /> : <Navigate to={link} />;
};

export default ProtectedRoutes;
